module.exports = __webpack_public_path__ + "img/service2-05.d7b6764c.png";